import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logoMyH from "../assets/images/logonMyh.png";
import { userEvent } from "../controller";

export default function Loginmyu() {
  const [login, setLogin] = useState(true);
  const [info, setInfo] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    async function runStep() {
      const code = localStorage.getItem("code");
      if (code) {
        const responseX = await fetch(
          "https://adminsukien.myu.vn/apis_v1/api/userinfo?code=" + code,
          {
            method: "get",
            headers: { "Content-Type": "application/json" },
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              localStorage.removeItem("code");
              setLogin(true);
            }
          })
          .catch((error) => {
            console.log(error);
            localStorage.removeItem("code");
            setLogin(true);
          });
        if (responseX) {
          setInfo(responseX);
          localStorage.removeItem("href");
          setLogin(false);
        }
      } else {
        setLogin(true);
      }
    }
    runStep();
  }, []);

  async function handleLogin(e) {
    await localStorage.setItem("href", window.location.pathname);
    window.location.replace(
      "https://id.myu.vn/account/login?response_type=code&grant_type=sso&client_id=myu_web&redirect_uri=https://minigametet2026.vhu.edu.vn/callback"
    );
  }

  const createUserMyu = async (info) => {
    try {
      await userEvent.createUserEventMyu({
        mail: info?.email,
        role: 0, // 0: user, 1: captain, 2: admin
        event: "minigametet2026",
      });
    } catch (error) {
      console.error("Error creating user event Myu:", error);
      throw error;
    }
  };

  useEffect(() => {
    if (!login) {
      sessionStorage.setItem("islogged", true);
      sessionStorage.setItem("mail", info?.email);
      sessionStorage.setItem("info", JSON.stringify(info));
      sessionStorage.setItem("modeLogin", "myu");
      createUserMyu(info)
        .then(() => {
          // navigate("/user/events/");
          window.location.replace("/user/events/");
        })
        .catch((error) => {
          console.error("Error during user event creation:", error);
        });
    }
  }, [login, info, navigate]);

  return (
    <>
      <div className="bg-[#f6f6f6] w-full h-screen flex justify-center items-center p-2">
        <div className="shadow-lg rounded p-10 bg-white">
          <img src={logoMyH} alt="Logo Hung Hau" className="w-24 mx-auto" />
          {/* <p className="font-bold text-center text-gray-700 text-xl mt-4">Đăng nhập</p> */}
          <button
            onClick={handleLogin}
            className="flex justify-center py-5 px-20 border rounded my-3 hover:shadow hover:bg-slate-50 w-full items-center"
          >
            <p className="ml-2 text-lg text-gray-600">Login with MyU</p>
          </button>
        </div>
      </div>
    </>
  );
}
